import { render, staticRenderFns } from "./ContactoAddEdi.vue?vue&type=template&id=767644dc&"
import script from "./ContactoAddEdi.vue?vue&type=script&lang=js&"
export * from "./ContactoAddEdi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports